import { FormTab, useRecordContext } from "react-admin";

const HideableFormTab = ({ comparison, ...props }) => {
    const record = useRecordContext(props)
    const res = comparison(record)
    return res ? <FormTab {...props} /> : <></>
}

export default HideableFormTab;